import React from 'react'
import ReactDOM from 'react-dom'
import classes from './style.module.scss'
import useStyles from 'isomorphic-style-loader/useStyles'
import AddressForm from '../../../../components/address-form'
import { BlackMask } from '../../../../../components/mask'
import BottomToTop from '../../../../../components/transitions/bottom-to-top'
import { Iconfont } from '../../../../../components/icon/iconfont'
import { FormattedMessage } from 'react-intl'
import { IMAGE_GEEKO_LTD } from '../../../../../../constants'

const AddressEditor = props => {
    useStyles(classes)
    return <AddressForm {...props}/>
}


const WrappedEditor = props => {
    useStyles(classes)
	return <React.Fragment>
		<BottomToTop in={props.show} className={classes.AddressContainer}>
			<div>
                <div className={classes.Hd}>
                    <div className={classes.Title}>
                        <FormattedMessage id="address_book" defaultMessage="Address Book"/>
						<div className={classes.Privacy}>
							<img src={`${IMAGE_GEEKO_LTD}/chicme/20230914024938035294.png`} alt="privacy" />
							<span><FormattedMessage id="privacy_protection" defaultMessage={"Privacy protection"}/></span>
						</div>
                    </div>
                    <Iconfont className={classes.Close} onClick={props.onClose}>&#xe7c9;</Iconfont>
                </div>
                <div className={classes.Bd}>
                    <AddressEditor {...props} />
                </div>
			</div>
		</BottomToTop>
		{props.show && <BlackMask onClick={props.onClose} />}
	</React.Fragment>
}


export default props => {

	if (typeof window === 'undefined')
		return null

	return ReactDOM.createPortal(
		<WrappedEditor {...props} />,
		document.getElementById('root')
	)
}